import styled from 'styled-components';
import FormGroup from 'components/common/FormGroup';
import Input from 'components/common/Input';
import Container from '../common/Container';

export const ConfirmationStyled = styled(Container)``;

export const Form = styled(FormGroup)`
  padding-top: 0.5rem;
`;

export const InputStyled = styled(Input)``;

export const Link = styled.p`
  padding: 0.5rem;
  text-align: center;
`;
